export const KEY_TARGETS = ['w', 'a', 's', 'd'] as const;
export type KeyTarget = (typeof KEY_TARGETS)[number];

export type Difficulty = 'easy' | 'normal' | 'hard';
export type FailMode = 'none' | 'points' | 'time';

export interface DifficultyProfile {
  spawnEveryMs: number;
  lifetimeMs: number;
  maxCircles: number;
}

export const DIFFICULTY_PROFILES: Readonly<Record<Difficulty, DifficultyProfile>> = Object.freeze({
  easy: { spawnEveryMs: 1500, lifetimeMs: 8000, maxCircles: 3 },
  normal: { spawnEveryMs: 1100, lifetimeMs: 6000, maxCircles: 4 },
  hard: { spawnEveryMs: 800, lifetimeMs: 4000, maxCircles: 5 },
});

export const DEFAULT_DIFFICULTY: Difficulty = 'easy';
export const DEFAULT_FAIL_MODE: FailMode = 'none';
export const DEFAULT_SOUND = true;
export const DEFAULT_MUSIC = false;

export const ROUND_DURATIONS = [30, 60, 90, 120] as const;
export type RoundDuration = (typeof ROUND_DURATIONS)[number];
export const DEFAULT_ROUND_SECONDS: RoundDuration = 60;

export const TARGET_RADIUS_REM = 5;
export const TARGET_HIT_RADIUS_REM = 5;
export const TARGET_SPAWN_MARGIN_REM = 6.875;
export const TARGET_MIN_SEPARATION_REM = 11.25;

export const SCORE_BASE = 10;
export const SCORE_COMBO_STEP = 2;
export const SCORE_COMBO_CAP = 10;

export const COMBO_AMP_THRESHOLD = 3;
export const COMBO_FLAME_THRESHOLD = 5;

export const TIME_PINK_THRESHOLD_S = 10;
export const TIME_ORANGE_THRESHOLD_S = 20;
export const TIME_TICK_THRESHOLD_S = 6;

export const POINTS_PENALTY_TIMEOUT = 5;
export const POINTS_PENALTY_WRONG = 3;
export const TIME_PENALTY_TIMEOUT_S = 2;

export const STAR_THRESHOLDS = [30, 100, 200] as const;

export const PRAISE_WORDS = [
  'BOOP!',
  'ZOINKS!',
  'YEEHA!',
  'WOW!',
  'NICE!',
  'POW!',
  'YAY!',
  'ZAP!',
  'WHEE!',
] as const;
